import { IconContent } from '@icons';

export const crossBig: IconContent = {
    sm: '<path d="M7.163 8 2 13.163l.837.837L8 8.837 13.163 14l.837-.837L8.837 8 14 2.837 13.163 2 8 7.163 2.837 2 2 2.837 7.163 8Z" />',
};
